import { useEffect } from "react";
import api from "../../lib/api";
import { FALLBACK_CONCIERGE_WA } from "../../lib/concierge";

/**
 * WATI WhatsApp Chat Widget — official drop-in script, lazy-loaded.
 * The third-party script (~200KB+) is deferred until the visitor shows
 * intent (first scroll/tap/keypress) or 6s of idle — keeping it out of
 * the critical path for LCP/TBT. Branding is MyEcoTour's; the auto-reply
 * is configured inside WATI's dashboard, not here.
 */
export default function WatiWidget() {
    useEffect(() => {
        if (window.__watiInjected) return;

        const inject = (phoneNumber) => {
            const url = "https://wati-integration-prod-service.clare.ai/v2/watiWidget.js?11318";
            const s = document.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = url;

            const options = {
                enabled: true,
                chatButtonSetting: {
                    backgroundColor: "#1E3B2C",   // MyEcoTour deep forest green
                    ctaText: "Connect on WhatsApp",
                    borderRadius: "30",
                    marginLeft: "24",
                    marginRight: "0",
                    marginBottom: "24",
                    ctaIconWATI: false,
                    position: "left",
                },
                brandSetting: {
                    brandName: "MyEcoTour Concierge",
                    brandSubTitle: "Nature and Adventure",
                    brandImg: window.location.origin + "/logo-myecotour.webp",
                    welcomeText: "Hello, traveller.\nHow can our concierge help design your next quiet journey?",
                    messageText: "Hi MyEcoTour, I'd like to know more about your bespoke journeys. (Came from {{page_link}})",
                    backgroundColor: "#1E3B2C",
                    ctaText: "Start a conversation",
                    borderRadius: "30",
                    autoShow: false,
                    phoneNumber,
                },
            };

            s.onload = function () {
                if (typeof window.CreateWhatsappChatWidget === "function") {
                    window.CreateWhatsappChatWidget(options);
                }
            };

            const x = document.getElementsByTagName("script")[0];
            if (x && x.parentNode) {
                x.parentNode.insertBefore(s, x);
            } else {
                document.head.appendChild(s);
            }
        };

        const start = () => {
            if (window.__watiInjected) return;
            window.__watiInjected = true;
            // Admin-configurable concierge number — fetched before widget init.
            api.get("/settings/public")
                .then((r) => inject(r.data?.concierge_whatsapp || FALLBACK_CONCIERGE_WA))
                .catch(() => inject(FALLBACK_CONCIERGE_WA));
        };

        const events = ["scroll", "pointerdown", "touchstart", "keydown"];
        const onIntent = () => {
            cleanup();
            start();
        };
        const timer = setTimeout(onIntent, 6000);
        const cleanup = () => {
            clearTimeout(timer);
            events.forEach((e) => window.removeEventListener(e, onIntent));
        };
        events.forEach((e) => window.addEventListener(e, onIntent, { passive: true, once: false }));
        return cleanup;
    }, []);

    return null;
}
